import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BrandIconUtil } from '../../../utils/brand.util';

@Component({
  selector: 'kt-registration-tutorial',
  templateUrl: './registration-tutorial.component.html',
  styleUrls: ['./registration-tutorial.component.scss'],
  standalone: false,
})
export class RegistrationTutorialComponent implements OnInit {
  isCargoAiDomain = BrandIconUtil.isCargoAiDomain();
  isVideoClosed = false;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.onResize();
    this.cdr.detectChanges();
  }

  closeVideo() {
    this.isVideoClosed = true;
    this.cdr.detectChanges();
  }

  onResize() {
    this.isVideoClosed = window.innerWidth < 1250;
    this.cdr.detectChanges();
  }
}
